import { render, staticRenderFns } from "./passwordResetListing.vue?vue&type=template&id=aa1ab5de&scoped=true&"
import script from "./passwordResetListing.vue?vue&type=script&lang=js&"
export * from "./passwordResetListing.vue?vue&type=script&lang=js&"
import style0 from "./passwordResetListing.vue?vue&type=style&index=0&id=aa1ab5de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1ab5de",
  null
  
)

export default component.exports